// @mui
import { Localization, plPL } from '@mui/material/locale';

// ----------------------------------------------------------------------

/** MUI's plPL, but table ranges read "1-25 z 26": no en dash in app text. */
const plPLHyphenRanges: Localization = {
  components: {
    ...plPL.components,
    MuiTablePagination: {
      defaultProps: {
        ...plPL.components?.MuiTablePagination?.defaultProps,
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} z ${count !== -1 ? count : `ponad ${to}`}`,
      },
    },
  },
};

/**
 * The languages the app offers.
 *
 * Polish only for now — the product is Polish-facing and the English copy had
 * drifted behind it. `langs/en.ts` and its `enUS` MUI locale are deliberately
 * left in the repo: putting English back is adding its entry here, not
 * translating the app again.
 */
export const allLangs = [
  {
    label: 'Polski',
    value: 'pl',
    systemValue: plPLHyphenRanges,
    icon: '/assets/icons/flags/ic_flag_pl.svg',
  },
];

export const defaultLang = allLangs[0];
